import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import UserPickerModal from './UserPickerModal'

const UserPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation(['users', 'common'])
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiAccountBoxLine'}
        label={label || t('common:user')}
        value={compactString(value, { t: t, tField: 'userIds' })}
        onClick={() => setOpen(true)}
      />
      <UserPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default UserPicker
